import { DEFAULT_DISCOVER_URL, FILTERS } from '~/const';
import { createURL } from '~/pages/DiscoverPage/pages/SearchPage/helpers';
import { HITS_TYPES } from '~/pages/const';
import { buildGlossaryRoute, DISCOVER_GLOSSARY_ROUTE } from '~/routes';
import { translate } from '~/utils/translate';

export const getNavigationArray = (category: string, categoryUrl: string, term: string) => {
  return [
    {
      title: translate('page.discover.discover'),
      url: DEFAULT_DISCOVER_URL,
    },
    {
      title: translate('page.discover.glossary'),
      url: DISCOVER_GLOSSARY_ROUTE,
    },
    {
      title: category,
      url: `${DISCOVER_GLOSSARY_ROUTE}${categoryUrl}`,
    },
    {
      title: term,
    },
  ];
};

export const createDiscoverCategoryFilterUrl = (category, withDefault = true) => {
  const filterObj = {
    hierarchicalMenu: {
      [FILTERS.Category]: category?.parent
        ? `${category?.parent?.id} > ${category?.id}`
        : category?.id,
    },
    refinementList: {
      searchable_type: HITS_TYPES.GLOSSARY,
    },
  };
  return withDefault ? buildGlossaryRoute(createURL(filterObj)) : createURL(filterObj);
};

export const transformGlossaryTerm = (term, tenant) => {
  const categoriesObj = {
    lvl0: [],
    lvl1: [],
  };
  const categories = term?.categories?.reduce((total, category) => {
    if (category?.parent) {
      total.lvl0.push(category?.parent?.title);
      total.lvl1.push(`${category?.parent?.title} > ${category?.title}`);
    } else {
      total.lvl0.push(category?.title);
    }
    return total;
  }, categoriesObj);

  return {
    objectID: `App\\Models\\GlossaryTerm::${term?.id}`,
    id: term?.id,
    title: term?.title,
    searchable_type: HITS_TYPES.GLOSSARY,
    categories,
    tenant: tenant,
  };
};
